import type {CompRef, Pointer} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'
import type {FeatureData} from '../features/features'
import type {DalItem} from '@wix/document-manager-core'

export interface GetItemQueryIdData {
    compPointer: CompRef
    propName: string
}
export interface FeatureDataUpdate {
    compPointer: Pointer
    featureName: string
    featureData: FeatureData
}

export interface GetQueryIdEvent extends GetItemQueryIdData, HookEventData<'get_query_id'> {}
export interface FeatureDataUpdatedEvent extends FeatureDataUpdate, HookEventData<'after_feature_data_update'> {}

export interface BeforeGetRepeatedPointer {}

export interface DeserializeDataItem {
    deserializedDataItem: DalItem
    itemType: string
    itemId: string
    oldToNewIdMap?: Record<string, string>
}
export interface DeserializeDataItemEvent extends DeserializeDataItem, HookEventData<'after_deserialize_data_item'> {}

export interface BeforeGetRepeatedPointerEvent
    extends BeforeGetRepeatedPointer,
        HookEventData<'before_get_repeated_pointer'> {}

export const DATA_MODEL_HOOKS = {
    NAMESPACE_ITEM: {
        GET_QUERY_ID: createHookDefinition<'get_query_id', GetItemQueryIdData>('get_query_id')
    },
    GET_REPEATED_ITEM_POINTER: {
        BEFORE: createHookDefinition<'before_get_repeated_pointer', BeforeGetRepeatedPointer>(
            'before_get_repeated_pointer'
        )
    },
    FEATURE_DATA_UPDATE: {
        AFTER: createHookDefinition<'after_feature_data_update', FeatureDataUpdate>('after_feature_data_update')
    },
    SERIALIZE: {
        DATA_ITEM_AFTER: createHookDefinition<'after_serialize_data_item', {dataItem: DalItem}>(
            'after_serialize_data_item'
        )
    },
    DESERIALIZE: {
        DATA_ITEM_AFTER: createHookDefinition<'after_deserialize_data_item', DeserializeDataItem>(
            'after_deserialize_data_item'
        )
    }
}
